import { render } from "./AddEditorForm.vue?vue&type=template&id=7879031d"
import script from "./AddEditorForm.vue?vue&type=script&lang=js"
export * from "./AddEditorForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__